import styled from "@emotion/styled";
import { theme } from "@src/components/nessie-web";

export const RadioLabel = styled("label")`
  margin-left: 3px;
  font-size: 15px;
  line-height: 1.2;
  font-weight: 600;
  color: ${theme.colors.taro90};
`;

export const StyledForm = styled("form")`
  width: 100%;
  display: grid;
  text-align: left;
`;

export const CheckboxContainer = styled("div")`
  display: flex;
  flex-direction: row;
`;
